import * as React from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { CustomDisabledTextfield, CustomTextField } from "../../Components/custom-textfield/CustomTextField";
import { useState } from "react";
import * as CustomerService from '../../Services/customer-service';
import HeaderCustomer from "../../Layouts/header/HeaderCustomer";
import '../../Assets/Styles/Customer/LoginCustomer.css';
import '../../Assets/Styles/Customer/customer.css';
import '../../Assets/Styles/Customer/font-size.css';
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import OtpResetPassword from "./otp-reset-password";
import { warning } from "../../Components/custom-toast/CustomToast";
export default function ForgetPasswordCustomer({ objectDto, setObjectDto, setLoading, setState }) {
    const [poIdNumber, setPoIdNumber] = useState(localStorage.getItem("aaa") !== null ? JSON.parse(localStorage.getItem("aaa")).poIdNumber : "");
    const [password, setPassword] = useState({ pass: "", rePass: "" });
    const { i18n } = useTranslation();
    const resetPassword = async () => {
        if (password.pass == "" || password.rePass == "") {
            warning(t("missfield"), Date.now() + "null-value");
        } else {
            setLoading(true);
            const create = await CustomerService.resetPassword(objectDto, password, setPassword, setLoading);
            if (create) {
                localStorage.removeItem('aaa');
                localStorage.removeItem("state");
                setObjectDto({});
                setState("0");
                localStorage.setItem('state', "0");
            } else {
                document.getElementById("password").focus()
            }
            setPassword({ ...password, pass: "", rePass: "" })
        }
    }
    useEffect(() => {
    }, [i18n]);
    return (
        <>
            <HeaderCustomer />
            <div className="container-login-customer">
                <div className="box-login-right">
                    <span className="customer-title customer-color">{t("titleLoginCustomer1")}<br /><p className="customer-title-bold">{t("titleLoginCustomer2")}</p></span>
                    <Box className="box-login">
                        {objectDto.verifiedOTP === undefined || objectDto.verifiedOTP !== "1" ?
                            (objectDto.otp === undefined || objectDto.otp === "") ?
                                <CustomTextField className="css-textfield-login" margin="normal" fullWidth id="username" focusColor="#c4960c" placeholder={"Căn cước/ CCCD/ Hộ chiếu"} size="small" name="username"
                                    autoComplete="username" autoFocus value={poIdNumber}
                                    sx={{
                                        backgroundColor: "white",
                                        "&.MuiTextField-root": {
                                            marginTop: "5px", marginBottom: "5px"
                                        }
                                    }}
                                    onChange={(e) => { e.target.value !== "" ? setPoIdNumber(e.target.value) : setPoIdNumber("") }}
                                />
                                :
                                <CustomDisabledTextfield className="css-textfield-login" variant="outlined" label={""} size="small" fullWidth disabled value={poIdNumber}
                                    sx={{
                                        "&.MuiTextField-root": { marginTop: "5px", marginBottom: "5px" },
                                        "& .MuiInputBase-input.Mui-disabled": {
                                            backgroundColor: "white",
                                            WebkitTextFillColor: "gray"
                                        }
                                    }} />
                            : <></>
                        }
                        {objectDto.verifiedOTP !== undefined && objectDto.verifiedOTP === "1" ?
                            <>
                                <CustomTextField className="css-textfield-login" margin="normal" fullWidth id="password" focusColor="#c4960c" placeholder={"Mật khẩu mới"} size="small" name="username"
                                    autoComplete="password" autoFocus value={password.pass} type="password"
                                    sx={{
                                        backgroundColor: "white",
                                        "&.MuiTextField-root": {
                                            marginTop: "5px", marginBottom: "0px"
                                        }
                                    }}
                                    onChange={(e) => { e.target.value !== "" ? setPassword({ ...password, pass: e.target.value }) : setPassword({ ...password, pass: "" }) }}
                                    onKeyDown={(e) => e.keyCode === 13 ?
                                        (
                                            document.getElementById("repassword").focus()
                                        ) : null}
                                />
                                <CustomTextField className="css-textfield-login" margin="normal" fullWidth focusColor="#c4960c" size="small" name="repassword"
                                    placeholder={t("clientpassretype")} id="repassword" value={password.rePass}
                                    autoComplete="repassword" sx={{ backgroundColor: "white", "&.MuiTextField-root": { marginTop: "5px", marginBottom: "5px" } }} type="password"
                                    onChange={(e) => {
                                        e.target.value !== "" ? setPassword({ ...password, rePass: e.target.value }) : setPassword({ ...password, rePass: "" })
                                    }}
                                    onKeyDown={(e) => e.keyCode === 13 ?
                                        resetPassword() : null} />
                            </>
                            :
                            <></>
                        }
                        <Button variant="contained" className="css-button-login" component="label" fullWidth
                            onClick={() => {
                                setLoading(true);
                                CustomerService.verifyResetPassword(poIdNumber, setObjectDto, setLoading);
                            }}
                            sx={!(objectDto.otp === undefined || objectDto.otp === null && (objectDto.verifiedOTP === undefined || objectDto.verifiedOTP !== "1")) ? { display: "none" } : {
                                textAlign: "center", borderRadius: "5px", fontWeight: 500, backgroundColor: "#DFB246", color: "white", mb: 1,
                                ":hover": { backgroundColor: "#c99b13", fontWeight: 1000 }
                            }}>
                            <span className="css-button-login">{t("accept")}</span>
                        </Button>
                        <Button variant="contained" className="css-button-login" component="label" fullWidth
                            onClick={() => {
                                resetPassword();
                            }}
                            sx={(objectDto.verifiedOTP === undefined || objectDto.verifiedOTP !== "1") ? { display: "none" } : {
                                textAlign: "center", borderRadius: "5px", fontWeight: 500, backgroundColor: "#DFB246", color: "white", mb: 1,
                                ":hover": { backgroundColor: "#c99b13", fontWeight: 1000 }
                            }}>
                            <span className="css-button-login">{t("recreatepassword")}</span>
                        </Button>
                        {
                            objectDto.otp && (objectDto.verifiedOTP === undefined || objectDto.verifiedOTP !== "1") ?
                                <OtpResetPassword length={6} objectDto={objectDto} setPoIdNumber={setPoIdNumber} setObjectDto={setObjectDto} setLoading={setLoading} />
                                :
                                ""
                        }
                        {(objectDto.verifiedOTP === undefined || objectDto.verifiedOTP !== "1") ?
                            <span><label className="description-small-customer">{t("alreadyhasaccount")}</label>{" "}
                                <button className="button-register" style={{ paddingBottom: "5px" }} variant="text" onClick={() => {
                                    setState("0");
                                    localStorage.setItem("state", "0");
                                    CustomerService.LogOut(setObjectDto);
                                    setPoIdNumber("");
                                    localStorage.removeItem("countOtp");
                                    localStorage.removeItem("countWrongOtp");
                                }}>{t("login")}</button></span>
                            : <></>}
                    </Box>
                </div>
            </div>
        </>
    );
}
